import { BubbleMenu as BaseBubbleMenu, useEditorState } from '@tiptap/react';

import React, { useCallback, useState } from 'react';

import { LinkEditorPanel } from './link-editor-panel';
import { MenuProps } from './types';

export const LinkMenu = ({ editor, appendTo }: MenuProps): React.JSX.Element => {
	const [showEdit, setShowEdit] = useState(false);
	const { link, target } = useEditorState({
		editor,
		selector: (ctx) => {
			const attrs = ctx.editor.getAttributes('link');
			return { link: attrs.href, target: attrs.target };
		},
	});

	const shouldShow = useCallback(() => {
		const isActive = editor.isActive('link');
		return isActive;
	}, [editor]);

	const onSetLink = () => {};

	return (
		<BaseBubbleMenu
			editor={editor}
			pluginKey="textMenu"
			shouldShow={shouldShow}
			updateDelay={0}
			tippyOptions={{
				popperOptions: {
					modifiers: [{ name: 'flip', enabled: false }],
				},
				appendTo: () => {
					return appendTo?.current || document.body;
				},
				onHidden: () => {
					setShowEdit(false);
				},
			}}
		>
			{showEdit ? (
				<LinkEditorPanel
					initialUrl={link}
					initialOpenInNewTab={target === '_blank'}
					onSetLink={onSetLink}
				/>
			) : (
				<></>
			)}
		</BaseBubbleMenu>
	);
};

export default LinkMenu;
